// German for the page titles (PAGES[].title) — the sidebar and the topbar wrap them with t().
import { registerDe } from '../i18n/index.js';

registerDe({
  'Today': 'Heute',
  'Review': 'Prüfung',
  'Inbox': 'Posteingang',
  'People': 'Personen',
  'Person': 'Person',
  'Organisations': 'Organisationen',
  'Organisation': 'Organisation',
  'Pipeline': 'Pipeline',
  'Search': 'Suche',
  'Market': 'Markt',
  'Network': 'Netzwerk',
  'Signals': 'Signale',
  'Campaigns': 'Kampagnen',
  'Agents': 'Agenten',
  'Run': 'Lauf',
  'Sources': 'Quellen',
  'Admin': 'Verwaltung',
}, 'registry');
